import { ChangeDetectorRef, Component, effect, Input, input, output, ChangeDetectionStrategy } from "@angular/core";
import { take } from "rxjs";
import { HeaderFooterRow } from "../../models/headerFooterRow";
import { MetadataInfo } from "../../models/metadataInfo";
import { MoovStep } from "../../models/moovStep";
import { MoovVariable } from "../../models/moovVariable";
import { TransformationDefinition } from "../../models/transformationDefinition";
import { FileDefinitionService } from "../../services/FileDefinitionService";

@Component({ standalone:false,
    selector: 'app-edit-header-footer-rows',
    templateUrl: './edit-header-footer-rows.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./edit-header-footer-rows.component.scss']
  })
  export class EditHeaderFooterRowsComponent {
    readonly currentMoovStepArray = input<MoovStep[] | undefined>(undefined);
    readonly moovStep = input.required<MoovStep>();
    readonly availableMetadataInfo = input<MetadataInfo[] | undefined>(undefined);
    readonly availableCustomerVariables = input<MoovVariable[] | undefined>(undefined);
    readonly parameters = input<any>(undefined);
  
    readonly onValueChanged = output<any>();

    private precedingMoovStep?:MoovStep;
    private subComponentsValid:{rowIndex:number, valid:boolean}[]=[];

    public rows:HeaderFooterRow[]=[];
    public fileType?:string;
    public fieldDelimiter?:string;
    public initialized:boolean=false;

    constructor(private cd:ChangeDetectorRef, private fdService:FileDefinitionService){
      effect(()=>{
        this.setFileType();
      });
      effect(()=>{
        this.setParameters();
      });

    }

    private setParameters(){
      this.rows=[];
      if(this.parameters()?.value){
        let rowArray= JSON.parse(this.parameters().value);
        rowArray.forEach((r:any) => {
          let row = new HeaderFooterRow();
          this.rows!.push(Object.assign(row,r));
        });
      }
      this.cd.detectChanges();
      this.onValueChanged.emit({name:this.parameters.name, value:this.formValueAsJson, valid:this.formValuesValid, formDirty:false});
    }

    ngAfterViewInit(){
      this.precedingMoovStep=this.currentMoovStepArray()?.find(s=>s.sequenceNo===this.moovStep()?.sequenceNo-1);
      this.setFileType();
    }

    onAddRowClick(){
      let row = new HeaderFooterRow();
      row.rowIndex=this.rows.length;
      this.rows.push(row);
      this.cd.detectChanges();
      this.onValueChanged.emit({name:this.parameters.name, value:this.formValueAsJson, valid:this.formValuesValid, formDirty:true});
    }

    onDeleteRowClick(row:HeaderFooterRow){
      let rowIndex=this.rows.indexOf(row);
      this.rows.splice(rowIndex,1);
      let index=this.subComponentsValid.findIndex(sc=>sc.rowIndex==row.rowIndex);
      if(index>-1) this.subComponentsValid.splice(index,1);
      this.cd.detectChanges();
      this.onValueChanged.emit({name:this.parameters.name, value:this.formValueAsJson, valid:this.formValuesValid, formDirty:true});
    }

    onRowValueChanged($event:{rowIndex:number, type:string, fieldDelimiter:string, formValid:boolean, formValue:string, formDirty:boolean}){
      const row = this.rows.find(row=>row.rowIndex==$event.rowIndex);
      if(row){
        row.type = $event.type;
        row.fieldDelimiter = (row.type=='csv')?$event.fieldDelimiter:undefined;
        row.rowComponents = JSON.parse($event.formValue);
        const index=this.subComponentsValid.findIndex(sc=>sc.rowIndex==row.rowIndex);
        if(index>-1) this.subComponentsValid[index].valid=$event.formValid; 
        else this.subComponentsValid.push({rowIndex:row.rowIndex, valid:$event.formValid});
        this.onValueChanged.emit({name:this.parameters.name, value:this.formValueAsJson, valid:this.formValuesValid, formDirty:$event.formDirty});
      }
    }

    private setFileType(){
      this.initialized=false;
      if(this.precedingMoovStep?.outputFormatId){
          if(this.precedingMoovStep.outputFormatType=="fd"){
              this.fdService.getFileDefinitionById(false, this.precedingMoovStep.outputFormatId).pipe(take(1)).subscribe((fd)=>{
                  this.fileType = fd.type;
                  this.fieldDelimiter = fd.fieldDelimiter;
                  this.initialized=true;
                  this.cd.detectChanges();
              });
          }
          else if(this.precedingMoovStep.outputFormatType=="td"){
              this.fdService.getTransformationDefinitionById(false, this.precedingMoovStep.outputFormatId).pipe(take(1)).subscribe((td:TransformationDefinition|undefined)=>{
                if(td){
                  this.fileType = td.outputFileType;
                  this.fieldDelimiter = td.fieldDelimiter;
                }
                this.initialized = true;
                this.cd.detectChanges();
              });
          }
      }
  }

    get formValueAsJson(){
      return JSON.stringify(this.rows);
    }

    get formValuesValid(){
      return this.subComponentsValid.findIndex(sc=>!sc.valid)==-1;
    }
  }  